module.exports = __webpack_public_path__ + "img/MDI-file-question-outline.8171bef3.svg";